export const MAX_RESOLUTION_GROUP_NAME_LENGTH = 64
export const MAX_RESOLUTION_NAME_LENGTH = 64
